<script lang="ts">
    export let value;
    export let text_off = "Off";
    export let text_on = "On";
</script>

<div class="switch">
    <label>
      {text_off}
      <input bind:value="{value}" type="checkbox">
      <span class="lever"></span>
      {text_on}
    </label>
  </div>